<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-xs-12 text--base chart__white">
        <HeatmapInsurance v-if="heatmapTitle" :content="heatmapTitle" />
      </div>
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import HeatmapInsurance from '@/components/content/chapter2/HeatmapInsurance.vue';

export default {
  name: 'App4Heatmap',
  components: {
    HeatmapInsurance,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    heatmapTitle() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'heatmap-insurance') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-02.json`);
  },
};
</script>

<style scoped lang="scss">
  .chart__white {
    background-color: #ffffff;
    padding: 60px 0;

    @media #{map-get($media-breakpoints, 'mobile')} {
      padding: 30px 0;
    }
  }
</style>